/* eslint-disable @typescript-eslint/no-explicit-any */
import { useEffect, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setTemplates, selectSelectedTemplate, selectTemplateCount } from '../redux/reducers/templateSlice';
import { IconWithBackground } from "@/subframe/components/IconWithBackground";
import { Badge } from "@/subframe/components/Badge";
import { Accordion } from "@/subframe/components/Accordion";
import TemplateList from '../components/templates/TemplateList';
import TemplateMessageSend from './templates/TemplateMessageSend';
import { RootState } from '../redux/store';
import axios from 'axios';

function Templates({ currentRecipient }: any) {
  const dispatch = useDispatch();
  const selectedTemplate = useSelector(selectSelectedTemplate);
  const templateCount = useSelector(selectTemplateCount);
  const token = useSelector((state: RootState) => state.auth.token);

  const fetchTemplates = useCallback(async () => {
    try {
      const response = await axios.get('https://api.insightssystem.com/api:uYdlVwac/web/templates', { headers: { "Content-Type": "application/json", ...(token && { Authorization: token }) } });
      dispatch(setTemplates(response.data));
    } catch (error) {
      console.error('Failed to fetch templates:', error);
    }
  }, [dispatch, token]);

  useEffect(() => {
    fetchTemplates();
  }, [fetchTemplates]);

  return (
    <div className="flex w-full flex-col items-start rounded-xl bg-white shadow-sm border border-neutral-200 hover:shadow-md transition-all duration-300 ease-in-out">
      <Accordion
        trigger={
          <div className="flex w-full items-center gap-4 pl-6 pr-10 py-4 hover:bg-neutral-50 transition-colors duration-200 rounded-t-xl">
            <IconWithBackground 
              size="medium" 
              icon="FeatherLayoutTemplate" 
              square={true} 
              className="shadow-sm"
            />
            <span className="grow shrink-0 basis-0 text-heading-3 font-heading-3 text-default-font font-semibold">
              Templates
            </span>
            <Badge 
              variant="neutral" 
              className="bg-brand-100 text-brand-700 border border-brand-200 font-medium px-3 py-1"
            >
              {templateCount}
            </Badge>
            <Accordion.Chevron className="text-neutral-500 transition-transform duration-200" />
          </div>
        }
      >
        <div className="flex flex-col w-full relative bg-gradient-to-b from-neutral-50/50 to-white">
          <div 
            className={`w-full transition-all duration-500 ease-in-out overflow-hidden ${
              selectedTemplate ? 'h-[280px]' : 'h-[520px]'
            }`}
          >
            <div className="h-full overflow-auto custom-scrollbar p-2">
              <TemplateList />
            </div>
          </div>
          
          {selectedTemplate && (
            <div className="w-full border-t border-solid border-neutral-200 bg-white shadow-inner">
              <div className="p-4">
                <TemplateMessageSend currentRecipient={currentRecipient}/>
              </div>
            </div>
          )}
        </div>
      </Accordion>
    </div>
  );
}

export default Templates;